import React from "react";
import LogoutContent from "../../components/Auth/LogoutContent";
import AuthBackgroundSlideshow from "../../components/AuthBackground/Slideshow";

const Logout = () => {
  return (
    <>
      {/* Animated Background Slideshow */}
      <AuthBackgroundSlideshow />
      <LogoutContent />
    </>
  );
};

export default Logout;
